import TextCell from 'components/TextCell';
import type { ManagedDepotsType } from '../..';

interface CellProps {
  rowData: ManagedDepotsType;
}

export default function TeamNameCell({ rowData: { sentinelTeam } }: CellProps) {
  return <TextCell text={sentinelTeam?.name} />;
}
